import { TRaidRankingsClientState } from '../libs/store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const GET_RAID_RANKINGS = 'GET_RAID_RANKINGS';
export const GET_RAID_RANKINGS_ERROR = 'GET_RAID_RANKINGS_ERROR';
export const SHOW_RAID_RANKINGS_SPINNER = 'SHOW_RAID_RANKINGS_SPINNER';

export type TGetRaidRankingsAction = TAction<any>;
export type TShowRaidRankingsSpinner = TAction<any>;

// Action Creators
export function createActionGetRaidRankings(
  instanceId: string,
  raidRankings: TRaidRankingsClientState
): TGetRaidRankingsAction {
  return {
    type: GET_RAID_RANKINGS,
    payload: {
      instanceId,
      data: raidRankings
    }
  };
}

export function setActionGetRaidRankingsError(instanceId: string, error: any): TGetRaidRankingsAction {
  return {
    type: GET_RAID_RANKINGS_ERROR,
    payload: {
      instanceId,
      error
    }
  };
}

export function createActionShowRaidRankingsSpinner(instanceId: string, show: boolean): TShowRaidRankingsSpinner {
  return {
    type: SHOW_RAID_RANKINGS_SPINNER,
    payload: {
      instanceId,
      show
    }
  };
}
